import logo from '../assets/logo.png';
import Spinner from 'react-bootstrap/Spinner';
import { version } from '../componentes/config';

function Conectando() {

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="row mt-5">
        <div className="card shadow">
          <div className="card-body">
            <div className="card-title">
              <img src={logo} className="img-fluid" alt="logo" style={{ maxHeight:400, maxWidth:300}}/>
              <h4 className='mt-3'>ECOSISTEMA TECNOLOGICO</h4>
              <h5 className='text-muted'>Versión {version}</h5>
              <h6 className='mt-3'>Por favor espere</h6>
              
              <h5 className="visually">Lo estamos conectando con el servidor...
              <Spinner animation="grow"  variant="primary" size="xl" role="status"></Spinner>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Conectando;
